import { useAuthStore } from '@/lib/store/authStore';

/**
 * Check if the current user has a provisioned company on Tenant Server.
 *
 * Returns true if:
 * - Direct mode (local dev) - always provisioned
 * - Control Plane mode with is_provisioned = true (site_status === 'active')
 *
 * Returns false if:
 * - Control Plane mode but not provisioned (user registered but tenant not yet active)
 */
export function useIsProvisioned(): boolean {
  const authMode = useAuthStore((state) => state.authMode);
  const isProvisioned = useAuthStore((state) => state.isProvisioned);

  // Direct mode (local dev) is always "provisioned"
  if (authMode === 'direct') {
    return true;
  }

  // Control Plane mode - check the isProvisioned flag from backend
  // This is based on tenant.site_status === 'active'
  return isProvisioned;
}
